import { findAll, isUnattached, setAttached } from "./dom";

export default () =>
  findAll(document, ".gk-redirect")
    .filter((element) => isUnattached("select", element))
    .map((element) => setAttached("select", element))
    .forEach((element) => {
      window.location = element.getAttribute("data-url");
    });
